import Vue from 'vue'
import Router from 'vue-router'
import Simulator from '@/modules/simulator/Simulator'

Vue.use(Router)



export default new Router({
  mode: 'history',
  base: '/coleira-peitoral-bopoty-lp2/custom/',
  routes: [
    {
      path: '/',
      name: 'simulator',
      component: Simulator
    },
  ],
})
